<template>
  <div class="strength">
    <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product-cont">
        <div class="product-box">
          <div class="strength-box">
            <div class="left">
              <div class="strength-title">{{ strengthList[0].title }}</div>
              <div class="strength-line"></div>
              <div class="strength-content m_t32">{{ strengthList[0].description }}</div>
              <div class="strength-list">
                <div class="strength-list-item" v-for="(item, index) in strengthList[0].technology" :key="index">
                  <img :src="item.image" alt="">
                  <p>{{ item.content }}</p>
                </div>
              </div>
            </div>
            <div class="right">
              <img :src="strengthList[0].image" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="throughput">
      <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
        <div class="product-cont">
          <div class="product-box">
            <div class="throughput-box">
              <div class="strength-title text-center">{{ strengthList[1].title }}</div>
              <div class="strength-content text-center m_t36"> {{ strengthList[1].description }}</div>
              <div class="throughput-image">
                <div class="item-image" v-for="(item, index) in strengthList[1].images" :key="index">
                  <img :src="item" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product-cont">
        <div class="product-box">
          <div class="strength-title text-center">{{ strengthList[2].title }}</div>
          <div class="strength-content text-center m_t36"> {{ strengthList[2].description }}</div>
          <div class="equipment-image m_t36">
            <el-carousel>

              <el-carousel-item v-for="item in strengthList[2].images" :key="item">
                <img :src="item" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { aboutList } from '@/request/api'
export default {
  props: {
    productId: {
      typeof: String,
      required: true,

    }
  },
  data() {
    return {
      strengthList: [],
      throughput: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      aboutList({ channel: this.productId }).then(res => {
        if (res.code == 1) {
          this.strengthList = res.data.list
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.strength-title {
  font-size: 36px;
  font-family: Arial-Bold, Arial;
  font-weight: bold;
  color: #333333;
}

.strength-content {
  font-size: 16px;
  color: #666;
  line-height: 30px;
}

.text-center {
  text-align: center;
}

.m_t32 {
  margin-top: 32px;
}

.m_t36 {
  margin-top: 36px;
}



.strength-box {
  display: flex;
  align-items: self-start;

  .left {
    width: 50%;
    margin-right: 50px;

    .strength-line {
      margin-top: 21px;
      width: 54px;
      height: 4px;
      background: #DB2733;
    }

    .strength-list {
      margin-top: 26px;
      padding: 43px 33px 15px 33px;
      background: #F7F7F7;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      // justify-content: space-between;

      .strength-list-item {
        // margin-right: 30px;
        width: 50%;
        margin-bottom: 28px;
        font-size: 14px;

        color: #333333;
        display: flex;
        align-items: center;

        p {
          margin-left: 11px;
        }

      }

      .strength-list-item :last-child {
        margin-bottom: 0;
      }
    }
  }

  .right {
    max-width: 60%;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.throughput {
  background: #F7F7F7;

  .throughput-image {
    margin-top: 33px;
    display: flex;
    flex-wrap: wrap;
    // width: 50%;
    justify-content: space-between;

    .item-image {
      width: calc((100% - 30px) /2);

      img {
        width: 100%;
        height: auto;
        // width: 23.08px !important;
        // height: 23.08px !important;
      }
    }

  }
}

.product-box {
  width: 100%;
}

.equipment-image {
  width: 100%;
  height: 532px;

  img {
    width: 100%;
    height: 100%;
  }

  >>>.el-carousel__container {
    width: 100%;
    height: 532px;
  }
  >>>.el-carousel__button {
    width: 55px;
    height: 5px;
    background: #FFFFFF;
    opacity: 1 !important;

  }
  >>>.el-carousel__indicator--horizontal.is-active .el-carousel__button {
    width: 55px;
    height: 5px;
    background: #DB2733;
  }
  >>>.el-carousel__arrow{
    display: none !important;
  }
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
}

@media screen and (max-width:767px) {
  .equipment-image {
  width: 100%;
  height:200px;

  img {
    width: 100%;
    height: 100%;
  }

  >>>.el-carousel__container {
    width: 100%;
    height: 200px;
  }
  >>>.el-carousel__button {
    width: 33px;
    height: 5px;
    background: #FFFFFF;
    opacity: 1 !important;

  }
  >>>.el-carousel__indicator--horizontal.is-active .el-carousel__button {
    width: 33px;
    height: 5px;
    background: #DB2733;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
}
  img {
    width: 100%;
    height: 100%;
  }

  .strength-box {
    display: block;

    .left {
      width: 100%;
    }

    .right {
      width: 100%;
      margin-top: 30px;

    }
  }

  .strength-title {
    font-size: 24px;
  }

  .strength-content {
    font-size: 16px;
  }

}</style>



// WEBPACK FOOTER //
// src/view/aboutUs/components/Companystrength.vue